"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentTerminalControlPaymentPresentedMethodValidation = void 0;
class PaymentTerminalControlPaymentPresentedMethodValidation {
    static isValid(enumValue) {
        if (typeof enumValue !== "number")
            return false;
        if (!(0 <= enumValue && enumValue <= 5)) {
            return false;
        }
        return true;
    }
}
exports.PaymentTerminalControlPaymentPresentedMethodValidation = PaymentTerminalControlPaymentPresentedMethodValidation;
